import React from 'react';
import { UserProvider } from './../Providers/UserProvider'



export default class NewsBox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			error: null
		};
	}

	handleSubmit = (e) => {
		var T = window.Texts.newsBox;
		e.preventDefault();
		this.setState({ error: null });
		UserProvider.mailkitSignUp(this.state.email,
			() => {
				window.gtm.onRegistrationNews("news-box");
				alert(T.finish);
				this.setState({ email: '' });
			},
			(err) => {
				this.setState({ error: err });
			});
	}

	render() {
		var T = window.Texts.newsBox;
		return (
			<div className="newslatter-cover">
				<h4><b>{T.novinkyDoemailu}</b></h4>
				<div className="form">
					<form autoComplete="off" id="newsLetterRow" onSubmit={(e) => this.handleSubmit(e)}>
						<input type="email" className={(this.state.error) ? 'form-control required email error' : 'form-control required email'} name="email" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} required="true" placeholder='' />
						{(this.state.error) ? <label id="Email-error" className="error" htmlFor="Email">{this.state.error}</label> : null}
						<button className="btn" type="submit" >{T.registrovat}</button>
						<p class="gdpr_news">
							<a target="_blank" href="/Home/Page/Protection#gdpr_news">
								{T.souhlasSeZpracovanimOsobnichUdaju}
							</a>
						</p>
					</form>
				</div>
			</div>);
	}
}
//inicializace

var element = document.getElementById("app-newsBox");
if (element) {
	ReactDOM.render(<NewsBox />, element);
}

